// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--29DPR","blogTitle":"style-module--blog-title--1qy-J","date":"style-module--date--1kSpy","content":"style-module--content--3nBvA"};